export default __webpack_public_path__ + "cd13f4be5028c483c2bb4f3c44a03ae2.jpg";